import type { FaireProductEntity } from "../../entity_types/product";

export const p_e8e5mkhxjx: FaireProductEntity = {
  token: "p_e8e5mkhxjx",
  type: "product",
  name: "Ultra Soft Cable Knit Throw Blanket - 54\" x72\"",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/949f6e684e95f9f9407aa1dbcf9fa7974db709c5739c11f9a004ebcdf97de5f1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/21e1eee32005e299953a8348b0ac42ac82631ccc278ea27fa43163e7844e2801.jpeg",
    "https://cdn.faire.com/fastly/a885f66af143fb5f829ac7bc968fe9e244dd59b8dfaa1e5308c61d77c93465fd.jpeg",
    "https://cdn.faire.com/fastly/a553e0e73cf6c6aae0a7830cee6ebb11ac5d77fed2a877f228d1c501af185367.jpeg",
    "https://cdn.faire.com/fastly/8290842d6d2e85f091597e9ccbb7865e1f779fb409ab6bfe38c97f88bdd582db.jpeg",
    "https://cdn.faire.com/fastly/894bc223d2149d4051596cb50fb23bf7f90dba64edaeadf1e015b4c3a7d9e3e7.jpeg"
  ],
  priceDollars: 65,
  description: "Wrap yourself in cloud-like softness and settle into comfort that feels indulgent from the very first touch. Whether draped across your favorite chair or layered at the foot of your bed, it's the cozy finishing touch every space deserves.\n\nFabrication:\nCrafted from Softies' signature Cable Knit Marshmallow fabric, this blanket combines timeless cable-knit texture with an ultra-plush feel. The cozy construction delivers warmth and softness while adding an elevated, inviting look to any room.\n\nFeatures:\n● 54\" x 72\"\n● Classic cable-knit texture for a timeless aesthetic\n● Ultra-soft, plush feel for exceptional comfort\n● Versatile design perfect for lounging, layering, or gifting\n\nMaterials & Care:\n● 100% Polyester\n● Machine wash cold with like colors\n● Tumble dry low; do not bleach\n\nBest For:\n● Cozy nights at home\n● Thoughtful gifting occasions\n● Adding warmth and texture to any living space\n",
  tags: [],
  msrpDollars: 130,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:08.891Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
